export default class AuthHelpers {
  public static formatEndpointActions(action: string): string {
    return `(${action})`;
  }
}
